import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  if (!properties.code || properties.code.trim() === '') {
    errors.push({
      key: 'code',
      message: 'JavaScript code is required',
    });
  }

  // Basic syntax check - look for return statement
  if (properties.code && !properties.code.includes('return')) {
    errors.push({
      key: 'code',
      message: 'Code must include a return statement',
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
